import React, { Component } from 'react';

import Header from '../components/Header';
import NotFoundContent from '../components/NotFoundContent';


class NotFound extends Component {

  

  render() {
    return (
      <div className='page'>
        <Header/>
        <NotFoundContent />
      </div>
    );
  }
}

export default NotFound;
